import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af1b7cfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pl-6 mb-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Version: ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Lizenz: ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Link: ", -1))
const _hoisted_5 = ["href"]

import licenseReport from "@/components/Impressum/licenseReport.json";
import { useI18n } from "vue-i18n";
import Toolbar from "@/components/Navigation/Toolbar";
import {
  IonPage,
  onIonViewWillEnter,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonText,
  IonCardContent,
  IonGrid,
  IonRow,
  IonCol,
} from "@ionic/vue";
import UserDialogButton from "@/components/User/UserDialogButton.vue";
import { useStore } from "@/composables/useTypedStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'libraries',
  setup(__props) {

const { t } = useI18n({ useScope: "global" });
const store = useStore();

onIonViewWillEnter(() => {
  store.commit("app/showBottomNavigation");
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(Toolbar), {
        title: _unref(t)('toolbar.libraries')
      }, {
        trailing: _withCtx(() => [
          _createVNode(UserDialogButton)
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(_unref(IonCard), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCardHeader), { class: "py-0" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCardTitle), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonText), null, {
                    default: _withCtx(() => [
                      _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(t)("libraries.titel")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonCardContent), { class: "container" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonGrid), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonRow), null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(licenseReport), (library, index) => {
                        return (_openBlock(), _createBlock(_unref(IonCol), {
                          key: index,
                          size: "6",
                          "size-xs": "12",
                          "size-sm": "12",
                          "size-md": "6",
                          "size-lg": "6",
                          "size-xl": "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonCard), { class: "adjust-size" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonCardTitle), { class: "pt-5 pl-5 ion-text-left" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(library.name), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_unref(IonCardContent), null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("ul", null, [
                                      _createElementVNode("li", null, [
                                        _hoisted_2,
                                        _createTextVNode(" " + _toDisplayString(library.installedVersion), 1)
                                      ]),
                                      _createElementVNode("li", null, [
                                        _hoisted_3,
                                        _createTextVNode(" " + _toDisplayString(library.licenseType), 1)
                                      ]),
                                      _createElementVNode("li", null, [
                                        _hoisted_4,
                                        _createElementVNode("a", {
                                          href: _unref(licenseReport)[index].link
                                        }, _toDisplayString(library.link), 9, _hoisted_5)
                                      ])
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})